import { IWPImage } from "@/src/types";
import React from "react";

import S from "./Employees.styled";
import { getImage } from "gatsby-plugin-image";

import AnchorLink from "react-anchor-link-smooth-scroll";

export interface Props {
  offices: {
    title: string;
    employees: {
      name: string;
      phone: string;
      image: IWPImage;
      title: string;
      email: string;
    }[];
  }[];
}

const Employees: React.FC<Props> = ({ offices }) => {
  return (
    <main className=" md:mx-auto pb-12">
      <div className="mt-5 sm:mt-8 flex md:flex-row flex-col items-center justify-center">
        {offices.map((office, index) => (
          <AnchorLink offset="300" href={"#" + office.title} key={index}>
            <div className="w-full flex items-center justify-center px-8 py-3 text-base font-medium rounded-full text-white bg-metlab-500 transition duration-200 ease-in-out hover:bg-green-600 md:py-4 md: md:px-10">
              {office.title}
            </div>
          </AnchorLink>
        ))}
      </div>

      {offices.map((office) => (
        <S.employeeList id={office.title} className={"relative w-full"}>
          <div className="md:mx-auto md:max-w-7xl pt-16 pb-24">
            <h3 className="text-4xl text-center mt-0">{office.title}</h3>

            <div className="flex lg:flex-row items-stretch sm:center flex-wrap">
              {office.employees.map((employee, idx) => {
                //  Logo image data
                const employeeImageData = employee.image?.localFile
                  ?.childImageSharp?.gatsbyImageData
                  ? getImage(
                      employee.image.localFile.childImageSharp.gatsbyImageData
                    )
                  : null;

                return (
                  <div
                    key={idx}
                    className={
                      "infoCard transition duration-400 ease-in-out m-2 flex flex-col text-center items-center sm:text-base text-sm relative overflow-hidden border border-mGray-200 justify-between"
                    }
                  >
                    <div className="relative pt-6">
                      <div className="rounded-full w-32 h-32 object-cover border border-2 border-metlab-500">
                        {employeeImageData && (
                          <S.EmployeeImage
                            image={employeeImageData}
                            alt="Bild på medarbetare"
                            className="rounded-full"
                            objectFit="cover"
                          />
                        )}
                      </div>
                    </div>
                    <div className="sm:py-4 sm:px-2 p-4 rounded-md">
                      <h4 className="mt-0 sm:text-2xl  font-bold mb-2">
                        {employee.name}
                      </h4>

                      <div className="px-6 text-sm">
                        <a
                          className="flex items-center justify-center transition duration-200 ease-in-out hover:text-metlab-500"
                          href={"tel:" + employee.phone}
                        >
                          <i className="bx bxs-phone mr-1 text-metlab-500"></i>{" "}
                          {employee.phone}
                        </a>
                        <a
                          className="flex items-center justify-center mt-1 transition duration-200 ease-in-out hover:text-metlab-500"
                          href={"mailto:" + employee.email}
                        >
                          <i className="bx bxs-envelope mr-1 text-metlab-500"></i>{" "}
                          {employee.email}
                        </a>
                      </div>
                    </div>
                    <div className="relative rounded-lg rounded-t-none border border-mGray-200 border-l-0 border-r-0 border-b-0 bg-gray-100 p-3 flex w-full justify-center items-center">
                      <p className="text-sm uppercase text-mGray-700">
                        {employee.title}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </S.employeeList>
      ))}
    </main>
  );
};

export default Employees;
